import { render, staticRenderFns } from "./DeactiveAdvisors.vue?vue&type=template&id=495b8456&scoped=true"
import script from "./DeactiveAdvisors.vue?vue&type=script&lang=js"
export * from "./DeactiveAdvisors.vue?vue&type=script&lang=js"
import style0 from "./DeactiveAdvisors.vue?vue&type=style&index=0&id=495b8456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b8456",
  null
  
)

export default component.exports